import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";

export class ImportRecurringServicesTableCtrl implements IController {
  services: any;
  queryString: any;
  selectedIds: any;
  isScrollable: any;
  selectedIdsChanged: Function;
  onEdit: Function;
  onDelete: Function;

  private selectedKeys: any;
  private expandedKeys: any;

  /* @ngInject */
  constructor() {
  }

  $onInit() {
    this.selectedKeys = {};
    this.expandedKeys = {};

    _.forEach(this.selectedIds, (selectedId) => {
      this.selectedKeys[selectedId] = true;
    });
  }

  $onChanges(changes) {
    if (changes.selectedIds && !changes.selectedIds.isFirstChange()) {
      this.$onInit();
    }
  };

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  toggleService(serviceId) {
    this.selectedKeys[serviceId] = !this.selectedKeys[serviceId];
    var selectedIds = _.map(this.selectedKeys, (value, key) => {
      if (value) return _.toNumber(key);
    });
    this.selectedIdsChanged({ids: _.compact(selectedIds)});
  }

  onToggleAllServices() {
    var selectedIds = !_.isEqual(this.selectedIds.length, this.services.length) ?
      _.map(this.services, 'rowNumber') : [];

    // ctrl.selectedIdsChanged({ids : _.compact(selectedIds)});
    this.selectedIdsChanged({ids: selectedIds});
  }

  onExpand(serviceId) {
    this.expandedKeys[serviceId] = !this.expandedKeys[serviceId];
  }

}

angular
  .module('bringoz.admin.deliveries')
  .component('importRecurringServicesTable', {
    bindings: {
      services: '<',
      queryString: '<',
      selectedIds: '<',
      isScrollable: '<?',
      selectedIdsChanged: '&',
      onEdit: '&',
      onDelete: '&'
    },
    template: require('./import-recurring-services-table.html').default,
    controller: ImportRecurringServicesTableCtrl
  });
